import { render, staticRenderFns } from "./index.vue?vue&type=template&id=066974c8&scoped=true"
import script from "./guide.js?vue&type=script&lang=js&external"
export * from "./guide.js?vue&type=script&lang=js&external"
import style0 from "./guide.css?vue&type=style&index=0&id=066974c8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066974c8",
  null
  
)

export default component.exports